import React, { useEffect } from "react";
import { getTransactions } from '../../../slices/transactions'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { SvgSearch, SvgFilter } from "../../../components/svg";
import { TransactionTable } from "../../../components/table/table_transactionslist";
import { Button } from "../../../components/button";

const TransactionList = ({ callBack }) => {

    return (
        <div className="container-fluid transactions-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">{gettext('Transactions')}</h1>
                </div>
            </div>
            <TransactionTable callBack={callBack} />
        </div>

    )

}

export default TransactionList